// ページ内アンカーリンクのスクロールエフェクト // Scrolling effect for anchor links within the page
// ヘッダーが固定の場合はheaderHightにヘッダーの高さを設定(PC/SP要設定) // Set header height to headerHight if header is fixed (PC/SP setting required)
jQuery(function ($) {
  var headerHeight = $("header").innerHeight() + 10; // ヘッダー追従の場合 // if header following
  $('a[href^="#"]').click(function () {
    var href = $(this).attr("href");
    var target = $(href == "#" || href == "" ? "html" : href);
    if (target.length > 0) {
      var position = target.offset().top - headerHeight;
      $("html, body").animate({ scrollTop: position }, 550, "swing");
      return false;
    }
  });
});

// ドロワーメニュー // Drawer menu
jQuery(function ($) {
  if ($("#toggle").length > 0) {
    $("#toggle").click(function () {
      $(this).toggleClass("toggle_active");
      $("#drawer_layer").fadeToggle();
      $("body").toggleClass("drawer_open");

      if ($(this).hasClass("toggle_active")) {
        $("nav").addClass("is_open");
        $("nav").removeClass("is_close");
      } else {
        $("nav").removeClass("is_open");
        $("nav").addClass("is_close");
      }
    });

    $("#drawer_layer").click(function () {
      $(this).fadeOut();
      $("#toggle").removeClass("toggle_active");
      $("body").removeClass("drawer_open");
      $("nav").removeClass("is_open");
      $("nav").addClass("is_close");
    });

    // エリア内リンク用 // For links within an area
    $("nav a").on("click", function () {
      // if (window.innerWidth <= 768) {
      if ($("#toggle:visible").length > 0) {
        $("#toggle").click();
      }
    });
  }
});

// ヘッダーアコーディオン
jQuery(function ($) {
  $(".l-header-nav__item--parent > .l-header-nav__parent").on("click", function (e) {
    if ($(".l-header-nav").hasClass("is_open")) {
      e.preventDefault();
      var $subMenu = $(this).next(".l-header-nav__sub");
      $(this).parent().toggleClass("is_active");
      $subMenu.stop(true, false).slideToggle(200);
    }
  });
});

// ヘッダー固定
jQuery(function ($) {
  if ($(".js-header-fixed").length > 0) {
    var headerHeight = $(".l-header").outerHeight();

    $(window).scroll(function () {
      var fvHeight = $(".js-header-fixed").outerHeight();
      var scrollTop = $(window).scrollTop();

      if (scrollTop > fvHeight) {
        $(".l-header").addClass("is-fixed");
      } else {
        $(".l-header").removeClass("is-fixed");
      }
    });
  }
});

// タブ
jQuery(function ($) {
  if ($(".js-faq-tab").length > 0) {
    $(".js-tab-item").on("click", function () {
      $(".js-tab-item").removeClass("is-active");
      $(this).addClass("is-active");
      $(".js-tab-content").removeClass("is-active");
      $(".js-tab-content").eq($(this).index()).addClass("is-active");
    });
  }
});

// サロン情報ページ　スライダー
jQuery(function ($) {
  const gallerySwiper = new Swiper(".js-gallery-slider", {
    loop: true,
    slidesPerView: "auto",
    speed: 10000,
    spaceBetween: 20,
    allowTouchMove: false,
    autoplay: {
      delay: 0,
    },
  });

	const noteSwiper = new Swiper(".js-note-slider", {
    loop: true,
    slidesPerView: 1,
    spaceBetween: 20,
		breakpoints: {
			768: {
				slidesPerView: 3,
			},
		},
		navigation: {
			nextEl: ".swiper-button-next",
			prevEl: ".swiper-button-prev",
		},
  });
});
